import type { Router } from "@vaadin/router";

/** Shared router reference, set by UmbMarketApp.firstUpdated */
export let appRouter: Router | undefined;

export function setAppRouter(router: Router) {
  appRouter = router;
}
